exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tags-container .add-button {\n  float: right;\n  margin-top: -14px;\n  cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/common/tags/tags.scss
// module id = YBkQ
// module chunks = 0